import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import SessionLayout from '../../layouts/SessionLayout'
import GoalSession1 from './GoalSession1'
import GoalSession2 from './GoalSession2'
import GoalSession3 from './GoalSession3'

export default class Goal extends Component {
  render() {
    const { match } = this.props
    const { session, patientID } = match.params

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          <SessionLayout title="titles.goal">
            {session === 'first' && <GoalSession1 />}
            {session === 'second' && <GoalSession2 />}
            {session === 'third' && <GoalSession3 />}
          </SessionLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/index.js